import './partners.scss';

export default () => {
};
